/* istanbul ignore file */
import CardShapedButton from './CardShapedButton';

export default CardShapedButton;
